// extracted by mini-css-extract-plugin
export default {"button":"FormInputButton-button-qvTt5 Button-button-paJ9a Link-link-RInnp","middleButton":"FormInputButton-middleButton-n2rOv"};